export default {"src":"/_next/static/media/mobile-default.88a36041.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};